import React from 'react';
import Icon from '../../../base/icons/components/Icon';
import { IconEnterFullscreen, IconExitFullscreen } from '../../../base/icons/svg';
import Tooltip from '../../../base/tooltip/components/Tooltip';
/**
 * Renders the local-video size control without allowing its interaction to
 * bubble into the thumbnail's pin handler.
 *
 * @param {IProps} props - Component props.
 * @returns {ReactElement}
 */
export default function SelfViewSizeToggle({ className, isCompact, label, onToggle }) {
    const stopPropagation = (event) => event.stopPropagation();
    const toggle = (event) => {
        event.stopPropagation();
        onToggle();
    };
    return (React.createElement(Tooltip, { content: label },
        React.createElement("button", { "aria-label": label, "aria-pressed": isCompact, className: className, "data-testid": 'self-view-size-toggle', onClick: toggle, onTouchEnd: stopPropagation, onTouchMove: stopPropagation, onTouchStart: stopPropagation, title: label, type: 'button' },
            React.createElement(Icon, { size: 18, src: isCompact ? IconEnterFullscreen : IconExitFullscreen }))));
}
